import password_rejected from './password-rejected.js';
const error = {
    general_required: `{{types, list(type: disjunction;)}} الزامی است`,
    general_invalid: `{{types, list(type: disjunction;)}} نامعتبر است`,
    invalid_min_max_input: 'مقدار ورودی باید بین {{minValue}} و {{maxValue}} باشد',
    invalid_min_max_length: 'طول مقدار ورودی باید بین {{minLength}} و {{maxLength}} باشد',
    username_required: 'نام کاربری الزامی است',
    password_required: 'رمز عبور الزامی است',
    username_exists: 'نام کاربری از قبل وجود دارد',
    username_should_not_start_with_number: 'نام کاربری نباید با عدد شروع شود',
    username_invalid_charset: 'نام کاربری فقط باید شامل حروف، اعداد یا زیرخط باشد.',
    username_too_short: 'نام کاربری باید حداقل {{min}} کاراکتر داشته باشد.',
    username_too_long: 'نام کاربری باید حداکثر {{max}} کاراکتر داشته باشد.',
    username_uppercase_not_allowed: 'حروف بزرگ در نام کاربری مجاز نیست.',
    username_lowercase_not_allowed: 'حروف کوچک در نام کاربری مجاز نیست.',
    username_numbers_not_allowed: 'اعداد در نام کاربری مجاز نیست.',
    username_underscore_not_allowed: 'زیرخط در نام کاربری مجاز نیست.',
    invalid_email: 'آدرس ایمیل نامعتبر است',
    invalid_phone: 'شماره تلفن نامعتبر است',
    passwords_do_not_match: 'رمزهای عبور شما مطابقت ندارند.',
    invalid_passcode: 'کد تأیید نامعتبر است.',
    device_code_required: 'کد الزامی است.',
    invalid_device_code: 'کد دستگاه نامعتبر است.',
    device_flow_aborted: 'درخواست ورود قطع شد.',
    invalid_connector_auth: 'مجوز نامعتبر است',
    invalid_connector_request: 'داده‌های اتصال‌دهنده نامعتبر است',
    unknown: 'خطای ناشناخته.',
    invalid_session: 'نشست یافت نشد. لطفاً به عقب برگردید و دوباره وارد شوید.',
    timeout: 'زمان درخواست به پایان رسید.',
    password_rejected,
    sso_not_enabled: 'ورود یکپارچه (SSO) برای این حساب ایمیل فعال نیست.',
    invalid_link: 'لینک نامعتبر است',
    invalid_link_description: 'توکن یک‌بار مصرف شما ممکن است منقضی شده یا دیگر معتبر نباشد.',
    captcha_verification_failed: 'تأیید کپچا ناموفق بود.',
    send_verification_code_failed: 'ارسال کد تأیید ناموفق بود. لطفاً بعداً دوباره تلاش کنید.',
    send_verification_code_failed_use_password: 'ارسال کد تأیید ناموفق بود. لطفاً به جای آن با رمز عبور وارد شوید.',
    sms_rate_limited: 'درخواست‌های کد تأیید بیش از حد است. لطفاً بعداً دوباره تلاش کنید.',
    terms_acceptance_required: 'پذیرش شرایط الزامی است',
    terms_acceptance_required_description: 'برای ادامه باید با شرایط موافقت کنید.',
    something_went_wrong: 'مشکلی پیش آمد',
    account_suspended: 'حساب معلق شد',
    account_suspended_description: 'این حساب معلق شده است. لطفاً برای کمک با مدیر تماس بگیرید.',
    access_denied: 'دسترسی رد شد',
    application_access_denied: 'شما مجاز به دسترسی به این برنامه نیستید. لطفاً با مدیر سیستم تماس بگیرید.',
    feature_not_enabled: 'شما مجاز به دسترسی به این ویژگی نیستید. لطفاً با مدیر سیستم تماس بگیرید.',
};
export default Object.freeze(error);
